import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "border-b-2" }, null, -1)
const _hoisted_3 = { class: "text-12px text-gray-lp-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createBlock("div", {
        onClick: ($event: any) => (_ctx.selectOption(option)),
        key: option.value,
        class: 
        `w-full px-4 pt-6 pb-8 space-y-3 text-center ${
          this.isDisabled(option) ? 'cursor-not-allowed' : 'cursor-pointer'
        } ${_ctx.isSelected(option) ? 'border-red-lp-100 border' : 'border'} ${
          _ctx.isDisabled(option) ? 'opacity-70' : ''
        }`
      
      }, [
        _createVNode("div", {
          class: 
          `font-semibold text-16px flex justify-center gap-x-4 items-center ${
            _ctx.isSelected(option) ? 'text-red-lp-100' : 'text-black-lp-300'
          }`
        
        }, [
          _createVNode("div", null, _toDisplayString(option.label), 1)
        ], 2),
        _hoisted_2,
        _createVNode("div", _hoisted_3, _toDisplayString(option.description), 1)
      ], 10, ["onClick"]))
    }), 128))
  ]))
}